<template>
  <!-- <q-spinner-ball size="50px" color="primary" /> -->
  <div v-if="showApp">
    <router-view />
  </div>
</template>

<script>
const setTokenGql = gql`
  mutation setToken($token: String!) {
    insert_b2b_push_token(objects: { token: $token }) {
      affected_rows
    }
  }
`

import { defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { provideApolloClient, useMutation } from '@vue/apollo-composable'
import { gql } from '@apollo/client/core'

import { apollo } from './utils/apollo'

import { checkAuth, subscribePush } from './utils/firebase'

import { loadingToggle } from './utils/loading'

export default defineComponent({
  name: 'App',
  setup() {
    window.router = useRouter()
    window.route = useRoute()
    window.store = useStore()

    // Включаем прелоадер
    loadingToggle(true)

    // Скрытие контента до отработки firebase и apollo
    const showApp = ref(false)
    const toggleShowApp = state => {
      showApp.value = state

      // Выключаем прелоадер
      loadingToggle(false)
    }

    const { mutate: setToken } = useMutation(setTokenGql)

    // Запрос на firebase и hasura

    ;(async () => {
      const jwtToken = await checkAuth()

      if (!jwtToken) {
        if (window.route.meta.category === 'login') {
          toggleShowApp(true)
        }

        return
      }

      if (window.route.meta.category === 'login') {
        return
      }

      const apolloClient = apollo(jwtToken)

      provideApolloClient(apolloClient)
      toggleShowApp(true)

      try {
        const pushToken = await subscribePush()
        if (!pushToken) {
          return
        }
        setToken({
          token: pushToken
        })
      } catch (error) {
        console.log('subscribePush', error)
      }
    })()

    return {
      showApp,
      show: ref(false)
    }
  }
})
</script>

<style lang="scss">
body {
  min-height: 100vh;
  background: $grey-2;
}
</style>
